module.exports = __webpack_public_path__ + "img/microaddons.6ba843b8.png";